import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const AnchorButton = ({ classNames, target, href, text, disabled }) => (
  <Link
    className={`${classNames} ${disabled ? 'disabled' : ''}`}
    target={target}
    to={href}
  >
    {text}
  </Link>
);

AnchorButton.propTypes = {
  classNames: PropTypes.string,
  target: PropTypes.string,
  href: PropTypes.string,
  text: PropTypes.string,
  disabled: PropTypes.bool
};

export default AnchorButton;
